export const oneSignalAppIds = {
  dev: '8f6abd5b-d360-4225-99dd-328a554db9b9',
  local: '638f7028-db54-4e48-bd29-a7a8be0f7edf',
  preview: 'c3d8a4b6-b9a1-41ec-be8c-4a8bb32b4b07',
  test: '',
  uat: '233cc137-0958-4448-8a60-0092babeca28',
  prod: 'a9ed14ec-d154-47a9-9719-846244f10b20',
};
